<template>
	<v-card v-if="item">
		<v-card-title @click="handlePreview">
			<span class="body-2">{{ item.title }}</span>
			<v-spacer></v-spacer>
			<p class="body-2 created-by mb-0 text-xs-right">
		  		<a @click.stop="handleRequesterClick" :href="`https://www.jeban.com/mypage/${item.user.id}`" target="_blank">{{ item.user.username }}</a>
			</p>
		</v-card-title>
		<v-card-text class="pa-0">
		    <v-card flat class="content-card" @click="handlePreview">
		        <v-layout>
		            <v-flex class="cover">
		                <v-img :src="contentCover" color="white" height="150px" :aspect-ratio="1200/630" @click="handlePreview"></v-img>
		            </v-flex>
		            <v-flex class="content-info px-3 pt-1 pb-3" xs9>
		            	<template v-if="item.issues.length">
							<h3 class="subheading pl-1">Tagged Issues</h3>
							<ul class="mb-3 pa-0 issues-ul">
								<li><v-chip label color="secondary" class="white--text" v-for="(issue, index) in item.issues">{{ issue.title }}</v-chip></li>
							</ul>
						</template>

		            	<template v-if="suggestions.byNectec.length">
							<h3 class="subheading pl-1">Suggested by &lsquo;AI FOR THAI&rsquo;</h3>
							<ul class="mb-3 pa-0 issues-ul">
								<li>
									<v-tooltip top v-for="(issue, index) in suggestions.byNectec" :key="index">
										<template v-slot:activator="{ on }">
											<v-chip label v-on="on">{{ issue.issueTitle }}</v-chip>
										</template>
										<span>{{ issue.score }}</span>
									</v-tooltip>
								</li>
							</ul>
						</template>

		            	<template v-if="suggestions.byImages.length">
							<h3 class="subheading pl-1">Annotated from images within content</h3>
							<ul class="mb-3 pa-0 issues-ul">
								<li v-if="suggestions.byImages.filter(s => s.score >= .8).length">
									<v-tooltip top v-for="(issue, index) in suggestions.byImages.filter(s => s.score >= .8)" :key="index">
										<template v-slot:activator="{ on }">
											<v-chip label v-on="on">{{ issue.title }}</v-chip>
										</template>
										<span>{{ issue.score }}</span>
									</v-tooltip>
								</li>
								<li v-if="suggestions.byImages.filter(s => s.score < .8).length">
									<v-tooltip top v-for="(issue, index) in suggestions.byImages.filter(s => s.score < .8)" :key="index">
										<template v-slot:activator="{ on }">
											<v-chip outline label v-on="on">{{ issue.title }}</v-chip>
										</template>
										<span>{{ issue.score }}</span>
									</v-tooltip>
								</li>
							</ul>
						</template>

		            	<template v-if="suggestions.byTeam.length">
							<h3 class="subheading pl-1">Feature</h3>
							<ul class="mb-3 pa-0 issues-ul">
								<li><v-chip label v-for="(issue, index) in suggestions.byTeam">{{ issue.title }}</v-chip></li>
							</ul>
						</template>
		            </v-flex>
		        </v-layout>
		    </v-card>
		</v-card-text>
	</v-card>
</template>

<script>
	import * as config from '@/config'
	import * as types from '@/stores/mutation-types'

	import {authMixins} from '@/mixins/auth'

	export default {
		mixins: [authMixins],
		props: ['item'],
		data () {
			return {
				message: '',
				suggestions: {
					byNectec: [],
					byImages: [],
					byTeam: []
				}
			}
		},
		computed: {
			contentCover ()
			{
				return `https://www.jeban.com${this.item.coverUrl.replace('http://s.jeban.com', '').replace('http://www.jeban.com', '').replace('https://www.jeban.com', '')}`
			},
			contentKeys ()
			{
				return (this.item) ? {contentType: 'TOPIC', contentId: this.item.id} : {}
			}
		},
		methods: {
			handlePreview ()
			{
				this.$emit('preview', this.contentKeys)
			},
			fetchSuggestions () 
			{
				axios.get(`${config.BASE_URL}/topic/${this.item.id}/suggestedTags`)
					.then(response => {
						this.suggestions.byNectec = response.data.data.byNectec
						this.suggestions.byImages = response.data.data.byImages
						this.suggestions.byTeam = response.data.data.byTeam
					})
			}
		},
		mounted () {
			this.fetchSuggestions()
		},
		watch: {
			item: {
				handler (value, oldValue) {
					this.fetchSuggestions()
				},
				deep: true
			}
		}
	}
</script>

<style lang="scss">
	.is-unpublished {
		opacity: .54;
	}
	.content-title {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: calc(100% - 168px);
		font-weight: normal;
	}
	.v-alert {
		border-radius: 4px;
		color: #616161;
	}
	.created-by {
		color: #757575;
		a {
			color: inherit !important;
			font-weight: bold;
		}
	}

	.cover {
		.v-image__image {
			background-position: center top;
		}
	}
	.issues-ul {
		list-style-type: none;
	}

</style>
